import { Button } from '@chakra-ui/react';
import { SIGN_UP_LINK } from 'constants/links';
import { useAppSelector } from 'modules/Editor/store';
import { selectIsViewOnly } from 'modules/Editor/store/editorSettingsSelector';
import { ReactElement, memo } from 'react';
import { useTranslation } from 'react-i18next';

export const SignUpButton = memo((): ReactElement | null => {
  const { t } = useTranslation('common_navbar');
  const isViewOnly = useAppSelector(selectIsViewOnly);
  // Redirect to sign up
  const onClick = () => {
    window.open(SIGN_UP_LINK, '_self');
  };

  const testId = 'navbar-register-button';
  const label = t('navbar.sign-up-button');

  return (
    <Button variant='upgrade' size='sm' data-testid={testId} aria-label={label} onClick={onClick}>
      {isViewOnly ? t('navbar.create-your-own-button') : t('navbar.sign-up-button')}
    </Button>
  );
});

SignUpButton.displayName = 'SignUpButton';
